import React, { useEffect } from "react";
import { LANDING_CONFIG } from "../../config/landingConfig";
import ErrorBoundary from "./ErrorBoundary";
import "../../styles/Landing.css";
import "../../styles/LandingComponents.css";
import "../../styles/LandingAnimations.css";

const LandingLayout = ({ children }) => {
  const { seo, accessibility } = LANDING_CONFIG;
  
  useEffect(() => {
    // Add landing-page class to body when component mounts
    document.body.classList.add('landing-page');
    
    // Remove the class when component unmounts
    return () => {
      document.body.classList.remove('landing-page');
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="landing-container">
        {/* SEO and Accessibility */}
        <div className="sr-only">
          <h1>{seo.title}</h1>
          <p>{seo.description}</p>
        </div>
        
        {/* Skip to main content for keyboard users */}
        <a 
          href="#main-content" 
          className="skip-link"
          style={{
            position: 'absolute',
            left: '-9999px',
            zIndex: 999,
            padding: '8px 16px',
            background: '#007cba',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '4px',
          }}
          onFocus={(e) => {
            e.target.style.left = '6px';
            e.target.style.top = '6px';
          }}
          onBlur={(e) => {
            e.target.style.left = '-9999px';
            e.target.style.top = 'auto';
          }}
        >
          {accessibility.skipToContent}
        </a>

        {/* Main content */}
        <main id="main-content" role="main">
          {children}
        </main>

        {/* Live region for dynamic content announcements */}
        <div
          id="live-region"
          role="status"
          aria-live="polite"
          aria-atomic="true"
          style={{
            position: 'absolute',
            left: '-9999px',
            width: '1px',
            height: '1px',
            overflow: 'hidden',
          }}
        />
      </div>
    </ErrorBoundary>
  );
};

export default LandingLayout;